// ─────────────────────────────────────────────────────────────────────────────
// Analytics — Public API
// Importar sempre via: import { AnalyticsService } from '@app/core/analytics';
// ─────────────────────────────────────────────────────────────────────────────

export { AnalyticsService } from './analytics.service';
export { AnalyticsMapperService } from './analytics-mapper.service';
export { PromoAttributionService } from './promo-attribution.service';
export type { PromoAttribution } from './promo-attribution.service';
export { getFirebaseConfig, GA4_CURRENCY, SUGGESTED_LIST, suggestedListPlacement } from './analytics.config';
export type {
  GaItem,
  GaItemFacets,
  GaPromotionParams,
  GaEcommerceParams,
  GaPurchaseParams,
  GaShippingParams,
  GaPaymentParams,
  UiMessageParams,
  PurchaseOrigin,
  AnalyticsCheckoutOptions,
  SuggestedListContext,
} from './analytics.types';
export { PURCHASE_ORIGIN_LOJA, PURCHASE_ORIGIN_CLUBE, CLUBE_PAYMENT_TYPE } from './analytics.types';
export type { ClubePaymentType } from './analytics.types';
export { UI_ACTION } from './ui-message-actions';
export type { UiMessageAction } from './ui-message-actions';
